/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MOBILE_BREAKPOINT = 1023;
var LocationSection = function () {
  function LocationSection() {
    _classCallCheck(this, LocationSection);
    this.locationSection = document.querySelector('.paragraph--type--location-section');
    if (this.locationSection) {
      this.numberOfLocationsText = this.locationSection.querySelector('.num-of-locations-text');
      this.dumpedLabels = this.locationSection.querySelector('.dumped-labels');
      this.locationCards = Array.from(this.locationSection.querySelectorAll('.field--name-field-locations-teasers'));
      this.singularText = this.dumpedLabels.querySelector('.field--name-field-location-label').querySelector('.field__item').textContent;
      this.pluralText = this.dumpedLabels.querySelector('.field--name-field-locations-label').querySelector('.field__item').textContent;
      this.pageTitle = this.dumpedLabels.querySelector('.field--name-field-title .field__item');
      if (this.pageTitle) {
        this.pageTitle = this.pageTitle.textContent;
      } else {
        this.pageTitle = this.dumpedLabels.querySelector('.field--name-field-title').textContent;
      }
      this.locationsMap = this.locationSection.querySelector('#super-specialty-locations-map');
      if (this.locationsMap) {
        this.listText = this.dumpedLabels.querySelector('.field--name-field-list-view-label').querySelector('.field__item').textContent;
        this.mapText = this.dumpedLabels.querySelector('.field--name-field-map-view-label').querySelector('.field__item').textContent;
        this.mapButton = this.locationSection.querySelector('.map-button');
        this.mapButton.querySelector('.button-text').textContent = this.mapText;
        this.listButton = this.locationSection.querySelector('.list-button');
        this.listButton.querySelector('.button-text').textContent = this.listText;
        this.listView = this.locationSection.querySelector('.list-view');
        this.mapView = this.locationSection.querySelector('.map-view');
        this.setUpGlide();
        this.setListeners();
        this.setDesktopOrMobileView();
        this.isSuperSpecialty = true;
      }
    }
  }
  return _createClass(LocationSection, [{
    key: "setListeners",
    value: function setListeners() {
      var _this = this;
      this.mapButton.addEventListener('click', function () {
        _this.showMapView();
      });
      this.listButton.addEventListener('click', function () {
        _this.showListView();
      });
      window.addEventListener('resize', function () {
        _this.setDesktopOrMobileView();
      });
    }
  }, {
    key: "setDesktopOrMobileView",
    value: function setDesktopOrMobileView() {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        this.showDesktopView();
      } else {
        this.showMapView();
      }
    }
  }, {
    key: "showDesktopView",
    value: function showDesktopView() {
      this.listView.classList.remove('hidden');
      this.listButton.classList.add('hidden');
      this.mapView.classList.remove('hidden');
    }
  }, {
    key: "showListView",
    value: function showListView() {
      this.locationsMap.classList.add('hidden');
      this.mapView.classList.add('hidden');
      this.listView.classList.remove('hidden');
      this.listButton.classList.add('hidden');
      this.mapButton.classList.remove('hidden');
      this.locationCards.forEach(function (card) {
        card.classList.remove('glide__slide');
      });
    }
  }, {
    key: "showMapView",
    value: function showMapView() {
      this.locationsMap.classList.remove('hidden');
      this.mapView.classList.remove('hidden');
      this.listView.classList.add('hidden');
      this.mapButton.classList.add('hidden');
      this.listButton.classList.remove('hidden');
      this.locationCards.forEach(function (card) {
        card.classList.add('glide__slide');
      });
    }
  }, {
    key: "glideGoToTappedLocation",
    value: function glideGoToTappedLocation(index) {
      this.glide.go("=".concat(index));
    }
  }, {
    key: "setUpGlide",
    value: function setUpGlide() {
      this.glide = new Glide('.glide', {
        type: 'slider',
        startAt: 0,
        keyboard: true,
        animationDuration: 250,
        gap: 10,
        perView: 1,
        peek: {
          before: 0,
          after: 75
        }
      }).mount();
    }
  }, {
    key: "setNumberOfLocationsText",
    value: function setNumberOfLocationsText() {
      if (this.locationSection) {
        var realNumOfCards = this.locationCards.length;
        if (this.isSuperSpecialty) {
          realNumOfCards = this.locationCards.length / 2;
        }
        if (realNumOfCards > 1) {
          this.numberOfLocationsText.textContent = "".concat(realNumOfCards, " ").concat(this.pageTitle, " ").concat(this.pluralText);
        } else {
          this.numberOfLocationsText.textContent = "".concat(realNumOfCards, " ").concat(this.pageTitle, " ").concat(this.singularText);
        }
      }
    }
  }]);
}();
export { LocationSection as default };
(function () {
  var locationSection = new LocationSection();
  locationSection.setNumberOfLocationsText();
})(Drupal);